import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// El plan de la conversación (vigente + historial). Mientras `watch` es verdadero (la IA está trabajando) se vuelve a leer cada 3 s para verlo avanzar.
export function usePlan(conversationId, watch = false) {
  return useQuery({
    queryKey: ["plan", conversationId],
    queryFn: async () => (await apiClient.get(`/conversations/${conversationId}/plan`)).data,
    enabled: !!conversationId,
    refetchInterval: watch ? 3000 : false,
    staleTime: 10000,
    retry: false,
  });
}

// Archivar el plan vigente: pasa al historial y el Orquestador puede empezar uno nuevo.
export function useArchivePlan(conversationId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await apiClient.post(`/conversations/${conversationId}/plan/archive`)).data,
    onSuccess: (data) => queryClient.setQueryData(["plan", conversationId], data),
  });
}

// Editar el plan vigente a mano (Fase 2). body = { op: estado | agregar | texto | mover | quitar | titulo | evidencia | quitar_evidencia, base, step_id, text, state, direction, title, goal, kind, value, label, evidence_id }.
// `base` es la versión del plan que el usuario está viendo: si cambió, el servidor responde 409 y aquí se vuelve a leer el plan.
export function useEditPlan(conversationId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body) => (await apiClient.patch(`/conversations/${conversationId}/plan`, body)).data,
    onSuccess: (data) => queryClient.setQueryData(["plan", conversationId], data),
    onError: () => queryClient.invalidateQueries({ queryKey: ["plan", conversationId] }),
  });
}

// Todos los planes vigentes del proyecto (uno por conversación o tema). Se vuelve a leer cada vez que se abre la lista.
export function useProjectPlans(projectId, enabled = true) {
  return useQuery({
    queryKey: ["project-plans", projectId],
    queryFn: async () => (await apiClient.get(`/projects/${projectId}/plans`)).data,
    enabled: !!projectId && enabled,
    staleTime: 0,
    retry: false,
  });
}
